<template>
    <answers ref="answers"
             code_question_group="GQ25"
             danger_code="MCAL17"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
